import { UploadFile } from 'antd'

import { UploadItem } from './interface'

export const tarnsformUploadFile = ({
  uid,
  name,
  type,
  status,
  error,
  originFileObj
}: UploadFile): UploadItem => {
  const url = originFileObj ? URL.createObjectURL(originFileObj) : undefined

  return {
    uid,
    ossId: undefined,
    name: `${name}`,
    fileName: `${name}`,
    url,
    thumbUrl: url,
    type,
    status,
    error
  }
}
